<template>
  <div class="editor-overlay">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  props: ["mode"]
};
</script>

<style lang="stylus">
  .editor-overlay
    width: 100%
    position: relative
    background: #001249;
    z-index: 10
    height: 90px
    .instructions
      max-width: 400px
      margin: auto auto auto 0px
      line-height: 120%
      color: #FFF
</style>
